import React, {useState, useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import {useParams} from 'react-router-dom'
import ProductSearchPrincipleActive from '../../Components/ProductSearch/SearchPrincipleActive'
import {ENUM_MENU} from '../../Utils/constants'
import {addEventNameWithParams, logEvent} from '../../Utils/utils'
import ContentDetail from '../../Components/Product/Content'
import HeaderDetail from '../../Components/Product/HeaderDetail'
import FooterDetail from '../../Components/Product/FooterDetail'
import FindActivePrinciple from '../../Components/Product/FindActivePrinciple'

function MedicationSheet() {
  const history = useHistory()
  const [productId, setProductId] = useState(null)
  const [product, setProduct] = useState(null)
  const [results, setResult] = useState(null)
  const fromYappApp = localStorage.getItem('fromYappApp') === 'true'
  const [contactLaboratory, setContactLaboratory] = useState(false)
  const [searchPrincipalActive, setSearchPrincipalActive] = useState(false)
  const {code} = useParams()

  useEffect(() => {
    if (code) {
      const isProduct = history.location.state?.isProduct
      const product = history.location.state?.product
      if (isProduct) {
        setProduct(product)
        setProductId(code)
        clickShowDetail(product, code)
      } else {
        setSearchPrincipalActive(code)
      }
    }
  }, [code])

  function clickShowDetail(product, productId) {
    setSearchPrincipalActive(null)
    setResult({
      id: productId,
      product_id: productId,
      product: product,
      isComesFromMedicationSheet: true,
    })
  }

  const onClickSearch = (newValue) => {
    if (
      newValue?.data?.is_product === 1 ||
      [undefined, null].includes(newValue?.data?.is_product)
    ) {
      if (newValue?.value) {
        // setSearchPrincipalActive(null)
        let id = newValue.data.product_id
        addEventNameWithParams('medication_sheet_select_product', {
          product_id: id,
          product_name: newValue?.label,
        })
        history.push(`/pro/medication-sheet/${id}`, {
          isProduct: true,
          product: newValue.data,
        })
      } else {
        console.log('Error value')
      }
    } else {
      logEvent('AP Medication Sheet Checked', {
        'Active Principle Id': newValue?.data?.active_principle_id,
        'Active Principle Name': newValue?.data?.active_principle_name,
      })
      addEventNameWithParams('medication_sheet_select_active_principle', {
        product_name: newValue?.label,
        active_principle_id: newValue?.data?.active_principle_id,
      })
      history.push(
        `/pro/medication-sheet/${newValue?.data?.active_principle_id}`,
        {isProduct: false},
      )
    }
  }

  function goBack() {
    history.goBack()
  }

  function onSelectProduct(product) {
    history.push(`/pro/medication-sheet/${product.product_id}`, {
      isProduct: product.product_id,
      product: product,
    })
  }

  return (
    <>
      {!fromYappApp && (
        <div className="py-3 px-3">
          <div className="content-responsive mx-auto d-flex justify-content-between py-1 px-0 px-md-0">
            <div className="breadcrumbs c-pointer" onClick={goBack}>
              <a className="d-flex align-items-center">
                <i className="icon-chevron-right icon-reverse"></i>
              </a>
              <span className="txt-4--regular-pr">Volver</span>
            </div>
          </div>
        </div>
      )}
      <div id={'gtm-medication-sheet'} className="wrapper-location">
        <div className="content-responsive mx-auto pt-4">
          <h2 className="title-primary--xxl ">Buscador de medicamentos</h2>
          <p className="txt-paragraph">
            Encuentra aquí todo el contenido relacionado al medicamento que
            buscas.
          </p>
          <div className="">
            <ProductSearchPrincipleActive
              principleActive={true}
              request_from={ENUM_MENU.medication_sheet}
              className="hpt-16"
              onClickSearch={onClickSearch}
              isNotShow={true}
              placeholder={'Busca por marca o principio activo'}
            />
          </div>
          {searchPrincipalActive ? (
            <FindActivePrinciple
              active_principle_id={searchPrincipalActive}
              onSelectProduct={onSelectProduct}
            />
          ) : (
            results && (
              <>
                {productId && (
                  <>
                    <div className="d-flex justify-content-between align-items-center w-100 mt-4 mb-3">
                      <h4 className="title-primary--xl-bold mb-0">
                        Resultados de búsqueda
                      </h4>
                    </div>
                    <HeaderDetail product={product} />
                    <ContentDetail
                      results={results}
                      setContactLaboratory={setContactLaboratory}
                      contactLaboratory={contactLaboratory}
                    />
                    <FooterDetail
                      product={product}
                      contactLaboratory={contactLaboratory}
                    />
                  </>
                )}
              </>
            )
          )}
        </div>
      </div>
    </>
  )
}

export default MedicationSheet
